import React from 'react';
import './download.css';

const downloadItems = [
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u0967',
    description: '\u092e\u0902\u0926\u093f\u0930 \u0938\u091c\u093e\u0935\u091f\u0940\u0938\u093e\u0920\u0940 \u0909\u092a\u092f\u0941\u0915\u094d\u0924 \u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u0921\u093e\u0909\u0928\u0932\u094b\u0921 \u0915\u0930\u093e.',
    image: '/Assets/downloads/Seals1.png'
  },
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u0968',
    description: '\u0909\u0924\u094d\u0938\u0935 \u0906\u0923\u093f \u0935\u093f\u0936\u0947\u0937 \u092a\u0942\u091c\u093e \u092a\u094d\u0930\u0938\u0902\u0917\u0940 \u0935\u093e\u092a\u0930\u0923\u094d\u092f\u093e\u0938\u093e\u0920\u0940 \u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e.',
    image: '/Assets/downloads/Seals2.png'
  },
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u0969',
    description: '\u092d\u0915\u094d\u0924\u093e\u0902\u0938\u093e\u0920\u0940 \u0938\u0902\u0926\u0930\u094d\u092d \u092e\u094d\u0939\u0923\u0942\u0928 \u0920\u0947\u0935\u0932\u0947\u0932\u093e \u0938\u093e\u0927\u093e \u0906\u0923\u093f \u0906\u0915\u0930\u094d\u0937\u0915 \u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e.',
    image: '/Assets/downloads/Seals3.png'
  },
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u096a',
    description: '\u0935\u093f\u0936\u094d\u0935\u0938\u094d\u0924 \u092e\u0902\u0921\u0933 \u0906\u0923\u093f \u092e\u0902\u0926\u093f\u0930 \u0913\u0933\u0916\u0940\u091a\u093e \u092a\u093e\u0930\u0902\u092a\u0930\u093f\u0915 \u091a\u093f\u0928\u094d\u0939 \u0928\u092e\u0941\u0928\u093e.',
    image: '/Assets/downloads/Seals4.png'
  },
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u096b',
    description: '\u0936\u094d\u0930\u0940\u0928\u093e\u0925 \u092e\u094d\u0939\u0938\u094d\u0915\u094b\u092c\u093e \u0925\u0940\u092e\u0938\u093e\u0920\u0940 \u0935\u093e\u092a\u0930\u0924\u093e \u092f\u0947\u0908\u0932 \u0905\u0938\u093e \u092a\u094d\u0930\u0924\u0940\u0915\u093e\u0924\u094d\u092e\u0915 \u0928\u092e\u0941\u0928\u093e.',
    image: '/Assets/downloads/Seals5.png'
  },
  {
    title: '\u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u093e \u096c',
    description: '\u092e\u0902\u0926\u093f\u0930 \u0930\u091a\u0928\u093e \u0906\u0923\u093f \u0927\u093e\u0930\u094d\u092e\u093f\u0915 \u092a\u094d\u0930\u0924\u0940\u0915\u093e\u0902\u0938\u0939 \u0938\u091c\u093e\u0935\u091f\u0940\u0938\u093e\u0920\u0940 \u092f\u094b\u0917\u094d\u092f \u0928\u092e\u0941\u0928\u093e.',
    image: '/Assets/downloads/Seals6.png'
  }
];

const Download = () => {
  return (
    <div className="aaras-download-page">
      <section className="aaras-download-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>{'\u0921\u093e\u0909\u0928\u0932\u094b\u0921'}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <section className="aaras-download-section">
        <div className="container">
          <p className="aaras-download-intro">
            {'\u092e\u0902\u0926\u093f\u0930\u093e\u0936\u0940 \u0938\u0902\u092c\u0902\u0927\u093f\u0924 \u091a\u093f\u0928\u094d\u0939\u0947, \u0932\u094b\u0917\u094b \u0906\u0923\u093f \u0906\u0930\u093e\u0938 \u0928\u092e\u0941\u0928\u0947 \u092f\u0947\u0925\u0947 \u0921\u093e\u0909\u0928\u0932\u094b\u0921\u0938\u093e\u0920\u0940 \u0909\u092a\u0932\u092c\u094d\u0927 \u0906\u0939\u0947\u0924.'}
          </p>

          <div className="aaras-download-grid">
            {downloadItems.map((item) => (
              <article key={item.title} className="aaras-download-card">
                <div className="aaras-download-image">
                  <img src={item.image} alt={item.title} loading="lazy" />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                <a href={item.image} download className="aaras-download-button">
                  {'\u0921\u093e\u0909\u0928\u0932\u094b\u0921'}
                </a>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Download;
